import { render, staticRenderFns } from "./ComponentesLista.vue?vue&type=template&id=66eb228e&scoped=true&"
import script from "./ComponentesLista.vue?vue&type=script&lang=js&"
export * from "./ComponentesLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eb228e",
  null
  
)

export default component.exports